export const SeenChatTag = ({
    unseenChats,
    unseenAnnonChats,
    type,
  }: {
    unseenChats: number;
    unseenAnnonChats: number;
    type: 'chats' | 'annonChats';
  }) => {
    const number = type === 'chats' ? unseenChats : unseenAnnonChats;
  
    if (number === 0) return null;
  
    return (
      <div
        className="bg-danger text-white rounded-circle d-inline-flex align-items-center justify-content-center shadow"
        style={{
          width: '18px',
          height: '18px',
          fontSize: '0.7rem',
        }}
      >
        <span className="p-1 text-xxs">
            {number}
        </span>
      </div>
    );
  };
  